<template>
  <div>
<!--    <h4 style="margin:0 0 10px 0;">合同账款</h4>-->
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="item-box-content">
          <h5>费用总计</h5>
          <el-tooltip
            content="付款类型"
            placement="top"
          >
            <span
              style="color:#D42424;font-size:14px; margin-top:10px"
            >{{ queryParams.payType }}</span>
          </el-tooltip>
          <div style="text-align:center;">
            <v-echart
              ref="echartRefs2"
              :echartId="contractCreditId"
              :style="styleEchart"
              :options="cont"
            ></v-echart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item-box-content">
          <el-row>
            <el-col :span="12">
              <h5>应收账款</h5>
            </el-col>
          </el-row>
          <div style="text-align:center;margin-top:20px">
            <v-echart
              ref="echartRefs1"
              :echartId="receivablesFinId"
              :style="styleEchart"
              :options="recei"
            ></v-echart>
          </div>
        </div>
      </el-col>
      <el-col
        :span="8"
        style="height: 320px;overflow: hidden"
      >
        <div
          v-for="(item,i) in arrList"
          :key="i"
          style="margin-bottom: 24px;"
          class="item-box-content inner-box"
        >
          <div class="icon-box">
            <i
              :class="'iconfont ' +item.icon"
              style="font-size:24px;padding:0"
            ></i>
          </div>
          <div>
            <div style="color:#000000;font-size: 18px;">¥{{item.num|priceFilter}}</div>
            <div style="color: #83878A;margin-top:4px">{{item.name}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import vEchart from '@/components/module/echartsCRM'

export default {
  props: ['queryParams'],
  components: {
    vEchart
  },
  watch: {
    queryParams: {
      handler (val) {
        this.arrList = [
          {
            icon: 'icon-hetongjine',
            num: val.contractMoney,
            name: '合同金额'
          },
          {
            icon: 'icon-hetongwaifeiyong',
            num: val.extraTotal,
            name: '合同外费用（退货罚没）'
          },
          {
            icon: 'icon-tuihuojine',
            num: val.retreatTotal,
            name: '退货金额'
          }
        ]
        val.rate = +((val.accountPe / val.contractTotal) * 100).toFixed(2)
        this.fbcId = val.fbdId
        this.cont.series[1].data[0].value = val.allTotal.toFixed(2) // 费用总计
        this.recei.series[1].data[0].value = val.accountsPayable.toFixed(2) // 应付账款
        const contList = [
          {
            value: +val.accountsPaid || 0.0,
            name: '已付账款'
          },
          {
            value: +val.accountsPayable || 0.0,
            name: '应付账款'
          }
        ]
        this.$set(this.cont.series[0], 'data', contList)
        this.$set(this.cont.legend, 'formatter', (valex) => {
          const obj = contList.find((item) => item.name === valex)
          const value = obj.value
          const data =
            valex +
              '  |  ' +
              ((value / val.allTotal) * 100 || 0).toFixed(2) +
              '%' +
              '   ' +
              value.toFixed(2)
          return data
        })
        const receiList = [
          {
            value: (+val.accountsDue).toFixed(2) || 0.0,
            name: '已到期账款'
          },
          {
            value: (+val.accountsOutstanding).toFixed(2) || 0.0,
            name: '未到期账款'
          }
        ]
        this.$set(this.recei.series[0], 'data', receiList)
        this.$set(this.recei.legend, 'formatter', (val) => {
          let data
          if (val === '应付账款') {
            data = ''
          } else {
            const obj = receiList.find((ele) => ele.name === val)
            data = val + '  ' + (obj && obj.value)
          }
          return data
        })
        this.$refs.echartRefs1.refresh()
        this.$refs.echartRefs2.refresh()
      },
      deep: true
    }
  },
  data () {
    return {
      arrList: [],
      fbcId: null, // 坏账合同id
      styleEchart: {
        height: '250px'
      },
      contractCreditId: 'contractCreditId',
      cont: {
        tooltip: {
          trigger: 'item',
          formatter (params) {
            let content
            if (params.seriesName !== '中间文字') {
              content = `${params.marker}${params.name}：${params.value}`
            }
            return content
          }
        },
        legend: {
          orient: 'vertical',
          left: '50%',
          itemWidth: 8,
          itemHeight: 8,
          icon: 'circle',
          bottom: 'center',
          textStyle: {
            fontSize: 14
          },
          data: ['已付账款', '应付账款']
        },
        series: [
          {
            type: 'pie',
            center: ['25%', '50%'],
            radius: ['65%', '80%'],
            startAngle: 0,
            label: {
              show: false
            },
            data: [
              {
                value: 0,
                name: '已付账款'
              },
              {
                value: 0,
                name: '应付账款'
              }
            ],
            echartdata: [],
            itemStyle: {
              color ({ dataIndex }) {
                if (dataIndex === 0) {
                  return '#578DFF'
                }
                if (dataIndex === 1) {
                  return '#62CF83'
                }
                if (dataIndex === 2) {
                  return '#F26F84'
                }
              }
            }
          },
          {
            name: '中间文字',
            type: 'pie',
            center: ['25%', '50%'],
            radius: ['50%', '50%'],
            startAngle: 0,
            label: {
              show: true,
              position: 'center',
              formatter: ['{a|{c}}', '{b|{b}}'].join('\n'),
              rich: {
                b: {
                  fontSize: 12,
                  color: '#4E555B'
                },
                a: {
                  color: '#4E555B',
                  fontSize: 18
                }
              }
            },
            data: [{
              name: '费用总计',
              value: 0.0
            }],
            itemStyle: {
              color: '#fff'
            }
          }
        ]
      },
      receivablesFinId: 'receivablesFinId',
      recei: {
        tooltip: {
          trigger: 'item',
          formatter (params) {
            let content
            if (params.seriesName !== '中间文字') {
              content = `${params.marker}${params.name}：${params.value}`
            }
            return content
          }
        },
        legend: {
          orient: 'vertical',
          left: '60%',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14
          },
          icon: 'circle',
          bottom: 'center',
          date: ['已到期账款', '未到期账款']
        },
        series: [
          {
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['65%', '80%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            data: [
              {
                value: 0,
                name: '已到期账款'
              },
              {
                value: 0,
                name: '未到期账款'
              }
            ],
            itemStyle: {
              color ({ dataIndex }) {
                if (dataIndex === 0) {
                  return '#5AA5FF'
                }
                if (dataIndex === 1) {
                  return '#F8D95B'
                }
              }
            }
          },
          {
            name: '中间文字',
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['50%', '50%'],
            startAngle: 0,
            label: {
              show: true,
              position: 'center',
              formatter: ['{a|{c}}', '{b|{b}}'].join('\n'),
              rich: {
                b: {
                  fontSize: 12,
                  color: '#4E555B'
                },
                a: {
                  color: '#4E555B',
                  fontSize: 18
                }
              }
            },
            data: [{
              name: '应付账款',
              value: 0
            }],
            itemStyle: {
              color: '#fff'
            }
          }
        ]
      }
    }
  },
  methods: {
    // 坏账申请
    onBadDebtApplication () {
      this.$router.push({
        name: 'badDebtApplication',
        query: {
          id: this.$route.query.id,
          cusId: this.$route.query.cusId
        }
      })
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
  .item-box-content {
    box-sizing: border-box;
    height: 320px;

    h5 {
      font-size: 14px;
      margin: 0px !important;
    }

    p {
      font-size: 12px;
    }
  }

  .inner-box {
    padding: 22px 30px;
    height: 90px;
    display: flex;

    .icon-box {
      margin-right: 20px;
      text-align: center;
      width: 46px;
      line-height: 46px;
      font-size: 24px;
      background-color: #5AA5FF;
      color: #fff;
      border-radius: 4px;
      // padding: 12px;

    }
  }
</style>
